this.Urls = (function () {

    var Urls = {};

    var self = {
        url_patterns:{}
    };

    var _get_url = function (url_pattern) {
        return function () {
            var _arguments, index, url, url_arg, url_args, _i, _len, _ref,
                _ref_list, match_ref, provided_keys, build_kwargs;

            _arguments = arguments;
            _ref_list = self.url_patterns[url_pattern];

            if (arguments.length == 1 && typeof (arguments[0]) == "object") {
                // kwargs mode
                var provided_keys_list = Object.keys (arguments[0]);
                provided_keys = {};
                for (_i = 0; _i < provided_keys_list.length; _i++)
                    provided_keys[provided_keys_list[_i]] = 1;

                match_ref = function (ref)
                {
                    var _i;

                    // Verify that they have the same number of arguments
                    if (ref[1].length != provided_keys_list.length)
                        return false;

                    for (_i = 0;
                         _i < ref[1].length && ref[1][_i] in provided_keys;
                         _i++);

                    // If for loop completed, we have all keys
                    return _i == ref[1].length;
                }

                build_kwargs = function (keys) {return _arguments[0];}

            } else {
                // args mode
                match_ref = function (ref)
                {
                    return ref[1].length == _arguments.length;
                }

                build_kwargs = function (keys) {
                    var kwargs = {};

                    for (var i = 0; i < keys.length; i++) {
                        kwargs[keys[i]] = _arguments[i];
                    }

                    return kwargs;
                }
            }

            for (_i = 0;
                 _i < _ref_list.length && !match_ref(_ref_list[_i]);
                 _i++);

            // can't find a match
            if (_i == _ref_list.length)
                return null;

            _ref = _ref_list[_i];
            url = _ref[0], url_args = build_kwargs(_ref[1]);
            for (url_arg in url_args) {
            	var url_arg_value = url_args[url_arg];
            	if (url_arg_value === undefined || url_arg_value === null) {
            		url_arg_value = '';
            	} else {
            		url_arg_value = url_arg_value.toString();
            	}
                url = url.replace("%(" + url_arg + ")s", url_arg_value);
            }
            return '/' + url;
        };
    };

    var name, pattern, url, url_patterns, _i, _len, _ref;
    url_patterns = [
        
            [
                'control:adg\u002Dawards',
                [
                    
                    [
                        'control/awards/adg/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dcalendar',
                [
                    
                    [
                        'control/awards/adg/calendar/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dcategories',
                [
                    
                    [
                        'control/awards/adg/categories/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dcrafts',
                [
                    
                    [
                        'control/awards/adg/crafts/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Ddownloads',
                [
                    
                    [
                        'control/awards/adg/press\u002Dreleases\u002Dand\u002Ddownloads/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dhelp',
                [
                    
                    [
                        'control/awards/adg/help/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Drules',
                [
                    
                    [
                        'control/awards/adg/rules\u002Dand\u002Dspecifications/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dshow',
                [
                    
                    [
                        'control/awards/adg/show/%(action)s/',
                        [
                            
                            'action',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dsponsors',
                [
                    
                    [
                        'control/awards/adg/sponsors/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dsubmission\u002Dprint',
                [
                    
                    [
                        'control/awards/adg/print/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:adg\u002Dawards\u002Dsubmissions',
                [
                    
                    [
                        'control/awards/adg/submissions/%(year)s/%(kind)s/',
                        [
                            
                            'year',
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:admins',
                [
                    
                    [
                        'control/admins/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards',
                [
                    
                    [
                        'control/api/awards/adg.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dcalendar',
                [
                    
                    [
                        'control/api/awards/adg/calendar.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/calendar',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dcategories',
                [
                    
                    [
                        'control/api/awards/adg/categories.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/categories',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dcrafts',
                [
                    
                    [
                        'control/api/awards/adg/crafts.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/crafts',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Ddownloads',
                [
                    
                    [
                        'control/api/awards/adg/downloads.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/downloads',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dexport',
                [
                    
                    [
                        'control/api/awards/adg/export/%(kind)s.%(format)s',
                        [
                            
                            'kind',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/export/%(kind)s/',
                        [
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dhelp',
                [
                    
                    [
                        'control/api/awards/adg/help.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/help',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Drules',
                [
                    
                    [
                        'control/api/awards/adg/rules.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/rules',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dshow',
                [
                    
                    [
                        'control/api/awards/adg/show.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/show',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dsponsors',
                [
                    
                    [
                        'control/api/awards/adg/sponsors.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/sponsors',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dsubmission',
                [
                    
                    [
                        'control/api/awards/adg/submission/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/submission/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dsubmission\u002Dcreate',
                [
                    
                    [
                        'control/api/awards/adg/submission.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/submission',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dsubmission\u002Ddetails',
                [
                    
                    [
                        'control/api/awards/adg/submission/%(pk)s/details.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/submission/%(pk)s/details/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dsubmissions',
                [
                    
                    [
                        'control/api/awards/adg/year/%(year)s/%(kind)s.%(format)s',
                        [
                            
                            'year',
                            
                            'kind',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/year/%(year)s/%(kind)s/',
                        [
                            
                            'year',
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dyear',
                [
                    
                    [
                        'control/api/awards/adg/year/%(year)s.%(format)s',
                        [
                            
                            'year',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/year/%(year)s/',
                        [
                            
                            'year',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:adg\u002Dawards\u002Dyear\u002Darchive',
                [
                    
                    [
                        'control/api/awards/adg/year/archive.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/adg/year/archive/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:admin\u002Ddetail',
                [
                    
                    [
                        'control/api/admins/%(user_id)s.%(format)s',
                        [
                            
                            'user_id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/admins/%(user_id)s/',
                        [
                            
                            'user_id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:admin\u002Dlist',
                [
                    
                    [
                        'control/api/admins.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/admins/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:advertising\u002Dpositions',
                [
                    
                    [
                        'control/api/advertising/positions.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/advertising/positions/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:advertisingbanner\u002Darchive',
                [
                    
                    [
                        'control/api/advertising/banners/archive.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/advertising/banners/archive/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:advertisingbanner\u002Ddetail',
                [
                    
                    [
                        'control/api/advertising/banners/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/advertising/banners/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:advertisingbanner\u002Dlist',
                [
                    
                    [
                        'control/api/advertising/banners.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/advertising/banners/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:advertisingbanner\u002Drestore',
                [
                    
                    [
                        'control/api/advertising/banners/%(pk)s/restore.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/advertising/banners/%(pk)s/restore/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:api\u002Droot',
                [
                    
                    [
                        'control/api/.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archive',
                [
                    
                    [
                        'control/api/archive.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archivecollection\u002Ddetail',
                [
                    
                    [
                        'control/api/archive\u002Dcollection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive\u002Dcollection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archivecollection\u002Dlist',
                [
                    
                    [
                        'control/api/archive\u002Dcollection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive\u002Dcollection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archivefeaturedbook\u002Ddetail',
                [
                    
                    [
                        'control/api/archive\u002Dbook/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive\u002Dbook/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archivefeaturedbook\u002Dlist',
                [
                    
                    [
                        'control/api/archive\u002Dbook.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive\u002Dbook/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archivefeaturedimage\u002Ddetail',
                [
                    
                    [
                        'control/api/archive\u002Dimage/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive\u002Dimage/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:archivefeaturedimage\u002Dlist',
                [
                    
                    [
                        'control/api/archive\u002Dimage.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/archive\u002Dimage/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards',
                [
                    
                    [
                        'control/api/awards.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Dacademy',
                [
                    
                    [
                        'control/api/awards/academy.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/academy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Dacademy\u002Dyear',
                [
                    
                    [
                        'control/api/awards/academy/%(year)s.%(format)s',
                        [
                            
                            'year',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/academy/%(year)s',
                        [
                            
                            'year',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Demmy',
                [
                    
                    [
                        'control/api/awards/emmy.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/emmy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Demmy\u002Dyear',
                [
                    
                    [
                        'control/api/awards/emmy/%(year)s.%(format)s',
                        [
                            
                            'year',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/emmy/%(year)s',
                        [
                            
                            'year',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Dhof',
                [
                    
                    [
                        'control/api/awards/hall\u002Dof\u002Dfame.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/hall\u002Dof\u002Dfame/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Dhof\u002Dperson',
                [
                    
                    [
                        'control/api/awards/hall\u002Dof\u002Dfame/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/hall\u002Dof\u002Dfame/%(pk)s',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Dla',
                [
                    
                    [
                        'control/api/awards/lifetime\u002Dachievements.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/lifetime\u002Dachievements/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:awards\u002Dla\u002Dperson',
                [
                    
                    [
                        'control/api/awards/lifetime\u002Dachievements/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/awards/lifetime\u002Dachievements/%(pk)s',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefits',
                [
                    
                    [
                        'control/api/benefits.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/benefits/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitsclassitem\u002Ddetail',
                [
                    
                    [
                        'control/api/class/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/class/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitsclassitem\u002Dlist',
                [
                    
                    [
                        'control/api/class.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/class/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitsclassitem\u002Dpast',
                [
                    
                    [
                        'control/api/class/past.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/class/past/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitsclassitem\u002Dupcoming',
                [
                    
                    [
                        'control/api/class/upcoming.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/class/upcoming/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitsclasssection\u002Ddetail',
                [
                    
                    [
                        'control/api/class\u002Dsection/%(id)s.%(format)s',
                        [
                            
                            'id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/class\u002Dsection/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitsclasssection\u002Dlist',
                [
                    
                    [
                        'control/api/class\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/class\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitssection\u002Ddetail',
                [
                    
                    [
                        'control/api/benefits\u002Dsection/%(slug)s.%(format)s',
                        [
                            
                            'slug',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/benefits\u002Dsection/%(slug)s/',
                        [
                            
                            'slug',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:benefitssection\u002Dlist',
                [
                    
                    [
                        'control/api/benefits\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/benefits\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:contact',
                [
                    
                    [
                        'control/api/contact.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/contact/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:contactsection\u002Ddetail',
                [
                    
                    [
                        'control/api/contact\u002Dsection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/contact\u002Dsection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:contactsection\u002Dlist',
                [
                    
                    [
                        'control/api/contact\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/contact\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:dashboard',
                [
                    
                    [
                        'control/api/dashboard.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/dashboard/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:dues',
                [
                    
                    [
                        'control/api/dues.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/dues/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:duescategory\u002Ddetail',
                [
                    
                    [
                        'control/api/dues\u002Dcategories/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/dues\u002Dcategories/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:duescategory\u002Dlist',
                [
                    
                    [
                        'control/api/dues\u002Dcategories.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/dues\u002Dcategories/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:event\u002Ddetail',
                [
                    
                    [
                        'control/api/event/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/event/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:event\u002Dduplicate',
                [
                    
                    [
                        'control/api/event/%(pk)s/duplicate.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/event/%(pk)s/duplicate/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:event\u002Dlist',
                [
                    
                    [
                        'control/api/event.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/event/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:event\u002Dpast',
                [
                    
                    [
                        'control/api/event/past.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/event/past/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:event\u002Dupcoming',
                [
                    
                    [
                        'control/api/event/upcoming.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/event/upcoming/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:eventssection\u002Ddetail',
                [
                    
                    [
                        'control/api/events\u002Dsection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/events\u002Dsection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:eventssection\u002Dlist',
                [
                    
                    [
                        'control/api/events\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/events\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:faq',
                [
                    
                    [
                        'control/api/faq.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/faq',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:faq\u002Dquestions',
                [
                    
                    [
                        'control/api/faq/questions.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/faq/questions',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:faq\u002Dsection',
                [
                    
                    [
                        'control/api/faq/section/%(id)s.%(format)s',
                        [
                            
                            'id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/faq/section/%(id)s',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:faq\u002Dsections',
                [
                    
                    [
                        'control/api/faq/sections.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/faq/sections',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:footer',
                [
                    
                    [
                        'control/api/footer.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/footer/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild',
                [
                    
                    [
                        'control/api/guild.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dboard',
                [
                    
                    [
                        'control/api/guild\u002Dboard.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dboard/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dfaq',
                [
                    
                    [
                        'control/api/guild\u002Dfaq.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dfaq/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dhistory',
                [
                    
                    [
                        'control/api/guild\u002Dhistory.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dhistory/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Diatse',
                [
                    
                    [
                        'control/api/guild\u002Diatse.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Diatse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi',
                [
                    
                    [
                        'control/api/guild/pdi.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dapplication',
                [
                    
                    [
                        'control/api/guild/pdi/applications/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/applications/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dapplication\u002Ddetails',
                [
                    
                    [
                        'control/api/guild/pdi/applications/%(pk)s/details.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/applications/%(pk)s/details/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dapplications',
                [
                    
                    [
                        'control/api/guild/pdi/applications.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/applications/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dapplications\u002Dexport',
                [
                    
                    [
                        'control/api/guild/pdi/applications/export.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/applications/export/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dsupport',
                [
                    
                    [
                        'control/api/guild/pdi/support.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/support/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dtrainees',
                [
                    
                    [
                        'control/api/guild/pdi/trainees.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/trainees/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Duser\u002Ddetail',
                [
                    
                    [
                        'control/api/guild/pdi/users/%(user_id)s.%(format)s',
                        [
                            
                            'user_id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/users/%(user_id)s/',
                        [
                            
                            'user_id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Duser\u002Dlist',
                [
                    
                    [
                        'control/api/guild/pdi/users.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/users/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dpdi\u002Dwhat',
                [
                    
                    [
                        'control/api/guild/pdi/what.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild/pdi/what/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dstaff',
                [
                    
                    [
                        'control/api/guild\u002Dstaff.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dstaff/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guild\u002Dstaff\u002Dfaq',
                [
                    
                    [
                        'control/api/guild\u002Dstaff\u002Dfaq.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dstaff\u002Dfaq/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guildboardsection\u002Ddetail',
                [
                    
                    [
                        'control/api/guild\u002Dboard\u002Dsection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dboard\u002Dsection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guildboardsection\u002Dlist',
                [
                    
                    [
                        'control/api/guild\u002Dboard\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dboard\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guildbriefsection\u002Ddetail',
                [
                    
                    [
                        'control/api/guild\u002Dbrief\u002Dsection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dbrief\u002Dsection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guildbriefsection\u002Dlist',
                [
                    
                    [
                        'control/api/guild\u002Dbrief\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dbrief\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guildcommiteessection\u002Ddetail',
                [
                    
                    [
                        'control/api/guild\u002Dcommitees\u002Dsection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dcommitees\u002Dsection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:guildcommiteessection\u002Dlist',
                [
                    
                    [
                        'control/api/guild\u002Dcommitees\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/guild\u002Dcommitees\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:home',
                [
                    
                    [
                        'control/api/home.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/home/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:join',
                [
                    
                    [
                        'control/api/join.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/join/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:join\u002Dportfolio',
                [
                    
                    [
                        'control/api/join/portfolio.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/join/portfolio/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:joinsection\u002Ddetail',
                [
                    
                    [
                        'control/api/join\u002Dsection/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/join\u002Dsection/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:joinsection\u002Dlist',
                [
                    
                    [
                        'control/api/join\u002Dsection.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/join\u002Dsection/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:media',
                [
                    
                    [
                        'control/api/media.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/media/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:mediacategory\u002Ddetail',
                [
                    
                    [
                        'control/api/media\u002Dcategories/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/media\u002Dcategories/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:mediacategory\u002Dlist',
                [
                    
                    [
                        'control/api/media\u002Dcategories.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/media\u002Dcategories/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:mediaitem\u002Ddetail',
                [
                    
                    [
                        'control/api/media\u002Ditem/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/media\u002Ditem/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:mediaitem\u002Dlist',
                [
                    
                    [
                        'control/api/media\u002Ditem.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/media\u002Ditem/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:members',
                [
                    
                    [
                        'control/api/members.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/members/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:members\u002Dportfolio',
                [
                    
                    [
                        'control/api/members/%(id)s/portfolio.%(format)s',
                        [
                            
                            'id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/members/%(id)s/portfolio/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:members\u002Dsearch',
                [
                    
                    [
                        'control/api/members/search.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/members/search/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg',
                [
                    
                    [
                        'control/api/my\u002Dadg.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dcustom',
                [
                    
                    [
                        'control/api/my\u002Dadg/custom.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/custom',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Deducation',
                [
                    
                    [
                        'control/api/my\u002Dadg/education.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/education',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Delections',
                [
                    
                    [
                        'control/api/my\u002Dadg/elections.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/elections',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dmeeting\u002Dminutes',
                [
                    
                    [
                        'control/api/my\u002Dadg/meeting\u002Dminutes.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/meeting\u002Dminutes',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dmeetings',
                [
                    
                    [
                        'control/api/my\u002Dadg/meetings.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/meetings',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dred\u002Db',
                [
                    
                    [
                        'control/api/my\u002Dadg/red\u002Db.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/red\u002Db',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dred\u002Dc',
                [
                    
                    [
                        'control/api/my\u002Dadg/red\u002Dc.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/red\u002Dc',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dscreenings',
                [
                    
                    [
                        'control/api/my\u002Dadg/screenings.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/screenings',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadg\u002Dtransparency',
                [
                    
                    [
                        'control/api/my\u002Dadg/transparency.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/my\u002Dadg/transparency',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadgmeetingminutescategory\u002Ddetail',
                [
                    
                    [
                        'control/api/myadg\u002Dmeeting\u002Dminutes\u002Dcategories/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/myadg\u002Dmeeting\u002Dminutes\u002Dcategories/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:myadgmeetingminutescategory\u002Dlist',
                [
                    
                    [
                        'control/api/myadg\u002Dmeeting\u002Dminutes\u002Dcategories.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/myadg\u002Dmeeting\u002Dminutes\u002Dcategories/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:oembed',
                [
                    
                    [
                        'control/api/oembed.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/oembed/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:perspective',
                [
                    
                    [
                        'control/api/perspective.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/perspective/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:perspectivearticle\u002Ddetail',
                [
                    
                    [
                        'control/api/perspective\u002Darticle/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/perspective\u002Darticle/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:perspectivearticle\u002Dduplicate',
                [
                    
                    [
                        'control/api/perspective\u002Darticle/%(pk)s/duplicate.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/perspective\u002Darticle/%(pk)s/duplicate/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:perspectivearticle\u002Dlist',
                [
                    
                    [
                        'control/api/perspective\u002Darticle.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/perspective\u002Darticle/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:perspectiveissue\u002Ddetail',
                [
                    
                    [
                        'control/api/perspective\u002Dissue/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/perspective\u002Dissue/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:perspectiveissue\u002Dlist',
                [
                    
                    [
                        'control/api/perspective\u002Dissue.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/perspective\u002Dissue/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:press',
                [
                    
                    [
                        'control/api/press.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/press/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:presscontact\u002Ddetail',
                [
                    
                    [
                        'control/api/press\u002Dcontact/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/press\u002Dcontact/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:presscontact\u002Dlist',
                [
                    
                    [
                        'control/api/press\u002Dcontact.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/press\u002Dcontact/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:pressrelease\u002Ddetail',
                [
                    
                    [
                        'control/api/press\u002Drelease/%(pk)s.%(format)s',
                        [
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/press\u002Drelease/%(pk)s/',
                        [
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:pressrelease\u002Dlist',
                [
                    
                    [
                        'control/api/press\u002Drelease.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/press\u002Drelease/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:adg\u002Dawards',
                [
                    
                    [
                        'control/api/preview/awards/adg.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/awards/adg/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:adg\u002Dawards\u002Dceremony',
                [
                    
                    [
                        'control/api/preview/awards/adg/ceremony.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/awards/adg/ceremony/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:archive',
                [
                    
                    [
                        'control/api/preview/archive.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/archive/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:awards',
                [
                    
                    [
                        'control/api/preview/awards.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/awards/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:awards\u002Dacademy',
                [
                    
                    [
                        'control/api/preview/awards/academy.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/awards/academy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:awards\u002Demmy',
                [
                    
                    [
                        'control/api/preview/awards/emmy.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/awards/emmy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:awards\u002Dhonored',
                [
                    
                    [
                        'control/api/preview/awards/%(category)s.%(format)s',
                        [
                            
                            'category',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/awards/%(category)s/',
                        [
                            
                            'category',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:benefits',
                [
                    
                    [
                        'control/api/preview/benefits.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/benefits/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:benefits\u002Dsection',
                [
                    
                    [
                        'control/api/preview/benefits/%(slug)s.%(format)s',
                        [
                            
                            'slug',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/benefits/%(slug)s',
                        [
                            
                            'slug',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:class\u002Dsection',
                [
                    
                    [
                        'control/api/preview/benefits/education/%(class_id)s.%(format)s',
                        [
                            
                            'class_id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/benefits/education/%(class_id)s/',
                        [
                            
                            'class_id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:contact',
                [
                    
                    [
                        'control/api/preview/contact.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/contact/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:contact\u002Drepresentative',
                [
                    
                    [
                        'control/api/preview/contact/%(id)s.%(format)s',
                        [
                            
                            'id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/contact/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:event',
                [
                    
                    [
                        'control/api/preview/event.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/event/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:faq',
                [
                    
                    [
                        'control/api/preview/faq.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/faq/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:faq\u002Dsection',
                [
                    
                    [
                        'control/api/preview/faq/section.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/faq/section/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild',
                [
                    
                    [
                        'control/api/preview/guild.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Dapprentice',
                [
                    
                    [
                        'control/api/preview/guild/apprentice.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/apprentice/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Dapprentice\u002Ddetails',
                [
                    
                    [
                        'control/api/preview/guild/apprentice/details.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/apprentice/details/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Dapprentice\u002Dselected',
                [
                    
                    [
                        'control/api/preview/guild/apprentice/selected.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/apprentice/selected/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Dboard',
                [
                    
                    [
                        'control/api/preview/guild/board.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/board/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Dcommitees',
                [
                    
                    [
                        'control/api/preview/guild/commitees.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/commitees/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Dhistory',
                [
                    
                    [
                        'control/api/preview/guild/history.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/history/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:guild\u002Diatse',
                [
                    
                    [
                        'control/api/preview/guild/iatse.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/guild/iatse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:home',
                [
                    
                    [
                        'control/api/preview/home.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/home/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:join',
                [
                    
                    [
                        'control/api/preview/join.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/join/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:join\u002Dportfolio',
                [
                    
                    [
                        'control/api/preview/join/portfolio\u002Dreview.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/join/portfolio\u002Dreview/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:join\u002Dsection',
                [
                    
                    [
                        'control/api/preview/join/%(id)s.%(format)s',
                        [
                            
                            'id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/join/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:media',
                [
                    
                    [
                        'control/api/preview/media.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/media/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:media\u002Dcategory',
                [
                    
                    [
                        'control/api/preview/media/%(id)s.%(format)s',
                        [
                            
                            'id',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/media/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:members',
                [
                    
                    [
                        'control/api/preview/members.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/members/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:perspective',
                [
                    
                    [
                        'control/api/preview/perspective.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/perspective/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:perspective\u002Darticle',
                [
                    
                    [
                        'control/api/preview/perspective/article.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/perspective/article/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:press',
                [
                    
                    [
                        'control/api/preview/press.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/press/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:rates',
                [
                    
                    [
                        'control/api/preview/rates.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/rates/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:utilities\u002Dprivacy',
                [
                    
                    [
                        'control/api/preview/utilities/privacy.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/utilities/privacy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:preview:utilities\u002Dterms',
                [
                    
                    [
                        'control/api/preview/utilities/terms.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/preview/utilities/terms/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:privacy',
                [
                    
                    [
                        'control/api/privacy.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/privacy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:rates',
                [
                    
                    [
                        'control/api/rates.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/rates',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:rates\u002Dagreements',
                [
                    
                    [
                        'control/api/rates/agreements\u002Dand\u002Drates.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/rates/agreements\u002Dand\u002Drates',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:rates\u002Dlistings',
                [
                    
                    [
                        'control/api/rates/production\u002Dlistings.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/rates/production\u002Dlistings',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:api:terms',
                [
                    
                    [
                        'control/api/terms.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'control/api/terms/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:archive',
                [
                    
                    [
                        'control/archives/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:archive\u002Dbooks',
                [
                    
                    [
                        'control/archives/books/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:archive\u002Dcollections',
                [
                    
                    [
                        'control/archives/collections/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:archive\u002Dimages',
                [
                    
                    [
                        'control/archives/images/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards',
                [
                    
                    [
                        'control/awards/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Dacademy',
                [
                    
                    [
                        'control/awards/academy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Dacademy\u002Dyear',
                [
                    
                    [
                        'control/awards/academy/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/awards/academy/new/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Demmy',
                [
                    
                    [
                        'control/awards/emmy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Demmy\u002Dyear',
                [
                    
                    [
                        'control/awards/emmy/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/awards/emmy/new/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Dhof',
                [
                    
                    [
                        'control/awards/hall\u002Dof\u002Dfame/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Dhof\u002Dperson',
                [
                    
                    [
                        'control/awards/hall\u002Dof\u002Dfame/new/',
                        [
                            
                        ],
                    ],
                    
                    [
                        'control/awards/hall\u002Dof\u002Dfame/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Dla',
                [
                    
                    [
                        'control/awards/lifetime\u002Dachievement/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:awards\u002Dla\u002Dperson',
                [
                    
                    [
                        'control/awards/lifetime\u002Dachievement/new/',
                        [
                            
                        ],
                    ],
                    
                    [
                        'control/awards/lifetime\u002Dachievement/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:benefits',
                [
                    
                    [
                        'control/benefits/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:benefits\u002Dsection',
                [
                    
                    [
                        'control/benefits/%(slug)s/',
                        [
                            
                            'slug',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:class\u002Dsection',
                [
                    
                    [
                        'control/benefits/class\u002Dsection/%(id)s',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/benefits/class\u002Dsection/new/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:contact',
                [
                    
                    [
                        'control/contact/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:contact\u002Drepresentative',
                [
                    
                    [
                        'control/contact/representatives/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:control\u002Dtemp\u002Dfile\u002Duploads\u002Dp',
                [
                    
                    [
                        'control/api/upload_temp_files/%(_0)s/',
                        [
                            
                            '_0',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:dues',
                [
                    
                    [
                        'control/dues/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:dues\u002Dcategory',
                [
                    
                    [
                        'control/dues/new/',
                        [
                            
                        ],
                    ],
                    
                    [
                        'control/dues/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:event',
                [
                    
                    [
                        'control/events/%(section)s/%(id)s/%(action)s/',
                        [
                            
                            'section',
                            
                            'id',
                            
                            'action',
                            
                        ],
                    ],
                    
                    [
                        'control/events/%(section)s/%(id)s/',
                        [
                            
                            'section',
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/events/%(section)s/new/',
                        [
                            
                            'section',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:events',
                [
                    
                    [
                        'control/events/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/events/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:faq',
                [
                    
                    [
                        'control/faq/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:faq\u002Dsection',
                [
                    
                    [
                        'control/faq/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild',
                [
                    
                    [
                        'control/the\u002Dguild/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dboard',
                [
                    
                    [
                        'control/the\u002Dguild/board\u002D\u0026\u002Dcouncils/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/the\u002Dguild/board\u002D\u0026\u002Dcouncils/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dcommittees',
                [
                    
                    [
                        'control/the\u002Dguild/committees/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dfaq',
                [
                    
                    [
                        'control/the\u002Dguild/staff\u002D\u0026\u002Dfaq/faq/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dhistory',
                [
                    
                    [
                        'control/the\u002Dguild/local\u002D800\u002Dhistory/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Diatse',
                [
                    
                    [
                        'control/the\u002Dguild/iatse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi\u002Dapplication\u002Dprint',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/submissions/%(id)s/print/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi\u002Dapplications',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/submissions/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi\u002Dsupport',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/support/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi\u002Dtrainees',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/trainees/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi\u002Dusers',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/users/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dpdi\u002Dwhat',
                [
                    
                    [
                        'control/the\u002Dguild/production\u002Ddesign\u002Dinitiative/what/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dstaff',
                [
                    
                    [
                        'control/the\u002Dguild/staff\u002D\u0026\u002Dfaq/staff/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:guild\u002Dstaff\u002Dfaq',
                [
                    
                    [
                        'control/the\u002Dguild/staff\u002D\u0026\u002Dfaq/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:home',
                [
                    
                    [
                        'control/home/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:index',
                [
                    
                    [
                        'control/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:join',
                [
                    
                    [
                        'control/join/section/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/join/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:join\u002Dportfolio',
                [
                    
                    [
                        'control/join/portfolio\u002Dreview/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:login:action',
                [
                    
                    [
                        'control/login/%(action)s/%(code)s/',
                        [
                            
                            'action',
                            
                            'code',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:login:api:action',
                [
                    
                    [
                        'control/api/%(action)s/',
                        [
                            
                            'action',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:login:api:login',
                [
                    
                    [
                        'control/api/login/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:login:login',
                [
                    
                    [
                        'control/login/%(action)s/',
                        [
                            
                            'action',
                            
                        ],
                    ],
                    
                    [
                        'control/login/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:login:logout',
                [
                    
                    [
                        'control/logout/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:media',
                [
                    
                    [
                        'control/videos/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:media\u002Dsection',
                [
                    
                    [
                        'control/videos/new/',
                        [
                            
                        ],
                    ],
                    
                    [
                        'control/videos/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:members',
                [
                    
                    [
                        'control/directory/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg',
                [
                    
                    [
                        'control/my\u002Dadg/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dcustom',
                [
                    
                    [
                        'control/my\u002Dadg/custom/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Deducation',
                [
                    
                    [
                        'control/my\u002Dadg/promo\u002Db/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Delections',
                [
                    
                    [
                        'control/my\u002Dadg/elections/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dmeeting\u002Dminutes',
                [
                    
                    [
                        'control/my\u002Dadg/meeting\u002Dminutes/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dmeeting\u002Dminutes\u002Dcategory',
                [
                    
                    [
                        'control/my\u002Dadg/meeting\u002Dminutes/new/',
                        [
                            
                        ],
                    ],
                    
                    [
                        'control/my\u002Dadg/meeting\u002Dminutes/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dmeetings',
                [
                    
                    [
                        'control/my\u002Dadg/meetings/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dpromo\u002Db',
                [
                    
                    [
                        'control/my\u002Dadg/promo\u002Da/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dpromo\u002Dc',
                [
                    
                    [
                        'control/my\u002Dadg/promo\u002Dc/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dscreenings',
                [
                    
                    [
                        'control/my\u002Dadg/screenings/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:myadg\u002Dtransparency',
                [
                    
                    [
                        'control/my\u002Dadg/transparency/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:perspective',
                [
                    
                    [
                        'control/perspective/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:perspective\u002Darticle',
                [
                    
                    [
                        'control/perspective/articles/%(id)s/%(action)s/',
                        [
                            
                            'id',
                            
                            'action',
                            
                        ],
                    ],
                    
                    [
                        'control/perspective/articles/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/perspective/articles/new/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:perspective\u002Darticles',
                [
                    
                    [
                        'control/perspective/articles/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:perspective\u002Dissue',
                [
                    
                    [
                        'control/perspective/issues/new/',
                        [
                            
                        ],
                    ],
                    
                    [
                        'control/perspective/issues/%(id)s/',
                        [
                            
                            'id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:perspective\u002Dissues',
                [
                    
                    [
                        'control/perspective/issues/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:press',
                [
                    
                    [
                        'control/press/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:rates',
                [
                    
                    [
                        'control/rates\u002Dand\u002Dcontracts/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:rates\u002Dagreements',
                [
                    
                    [
                        'control/rates\u002Dand\u002Dcontracts/agreements\u002Dand\u002Drates/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:rates\u002Dlistings',
                [
                    
                    [
                        'control/rates\u002Dand\u002Dcontracts/production\u002Dlistings/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:temp\u002Dfile\u002Ddetect\u002Dcolor\u002Dtype',
                [
                    
                    [
                        'control/api/detect_color_type/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:temp\u002Dfile\u002Dupload',
                [
                    
                    [
                        'control/api/upload_temp_file/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:temp\u002Dfile\u002Dupload\u002Dp',
                [
                    
                    [
                        'control/api/upload_temp_file/%(_0)s/',
                        [
                            
                            '_0',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:temp\u002Dfile\u002Duploads',
                [
                    
                    [
                        'control/api/upload_temp_files/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:utilities',
                [
                    
                    [
                        'control/utilities/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:utilities\u002Dadvertising',
                [
                    
                    [
                        'control/utilities/advertising/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:utilities\u002Dadvertising\u002Dbanner',
                [
                    
                    [
                        'control/utilities/advertising/%(id)s/',
                        [
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'control/utilities/advertising/%(id)s/%(kind)s/',
                        [
                            
                            'id',
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:utilities\u002Dfooter',
                [
                    
                    [
                        'control/utilities/footer/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:utilities\u002Dprivacy',
                [
                    
                    [
                        'control/utilities/privacy\u002Dpolicy/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'control:utilities\u002Dterms',
                [
                    
                    [
                        'control/utilities/terms\u002Dof\u002Duse/',
                        [
                            
                        ]
                    ]
                    
                ]
            ]
        
    ];
    self.url_patterns = {};
    for (_i = 0, _len = url_patterns.length; _i < _len; _i++) {
        _ref = url_patterns[_i], name = _ref[0], pattern = _ref[1];
        self.url_patterns[name] = pattern;
        url = _get_url(name);
        Urls[name] = url;
        Urls[name.replace(/-/g, '_')] = url;
    }

    return Urls;
})();



// WEBPACK FOOTER //
// ./assets/js/django_js_control/reverse.js